let baseIntegrationPromise;
let homeShellPromise;

const loadBaseIntegration = () => {
    if (!baseIntegrationPromise) {
        baseIntegrationPromise = import('./base-integration').catch((error) => {
            baseIntegrationPromise = undefined;
            throw error;
        });
    }

    return baseIntegrationPromise;
};

const loadHomeShell = () => {
    if (!homeShellPromise) {
        homeShellPromise = import('@edreamsodigeo/frontend-shell/esm/funnels/Home/shell')
            .then((module) => module.homeShell)
            .catch((error) => {
                homeShellPromise = undefined;
                throw error;
            });
    }

    return homeShellPromise;
};

const getHomeShell = () => Promise.all([loadBaseIntegration(), loadHomeShell()])
    .then(([, homeShell]) => homeShell);

export function execute(cb) {
    return getHomeShell().then((homeShell) => homeShell.execute(cb));
}

export function preload() {
    return getHomeShell();
}
